
export default {
    name: 'SiteComments',
    props: {
        /**
         * Vuex auth object
         */
        auth: {
            type: Object,
            required: true,
        },
        /**
         * A blog id
         */
        blog: {
            type: Number,
            default: null,
        },
        /**
         * Should we be able to attach images to comments
         */
        canAttachImages: {
            type: Boolean,
            default: false,
        },
        /**
         * An array of comments
         */
        comments: {
            type: Array,
            default() {
                return [];
            },
        },
        /**
         * Show closed comments notice
         */
        closed: {
            type: Boolean,
            default: false,
        },
        /**
         * Is theis a comment form on job page
         */
        isJobComment: {
            type: Boolean,
            default: false,
        },
        /**
         * Should we filter contact details on submission?
         */
        filterContactDetails: {
            type: Boolean,
            default: false,
        },
        /**
         * A report id
         */
        report: {
            type: Number,
            default: null,
        },
        /**
         * Show comments form
         */
        showForm: {
            type: Boolean,
            default: true,
        },
        /**
         * The type of comment - comments, testimonials
         */
        type: {
            type: String,
            default: 'comments',
        },
        /**
         * An API endpoint to submit comments to
         */
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            allComments: this.comments,
            loading: false,
            pagination: {
                canLoadMore: this.comments.length >= 5,
                page: 1,
                perPage: 5,
            },
        };
    },
    watch: {
        comments(val) {
            this.allComments = val;
            this.pagination.canLoadMore = this.comments.length >= 5;
        },
    },
    methods: {
        addComment(comment, parent) {
            if (!comment.parent_id) {
                this.allComments.push(comment);
            } else {
                parent.replies.push(comment);
            }
            this.$emit('add-comment', comment);
        },
        async removeComment(comment, parent) {
            const { message } = await this.$axios.$delete(`${this.url}/${comment.id}`);
            this.$store.dispatch('setFlashMessage', { message });
            if (parent) {
                parent.replies = parent.replies.filter((checkComment) => checkComment !== comment);
            } else {
                this.allComments = this.allComments.filter((checkComment) => checkComment !== comment);
            }
        },
        loadMore() {
            if (!this.pagination.canLoadMore) {
                return;
            }
            this.loading = true;
            this.pagination.page += 1;
            this.$axios
                .$get(this.url, {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.perPage,
                    },
                })
                .then((response) => {
                    const newItems = response[this.type];
                    console.log(newItems.data.length, this.pagination.perPag);
                    if (newItems.current_page === newItems.last_page) {
                        this.pagination.canLoadMore = false;
                    }
                    this.allComments = newItems.data.concat(this.allComments);
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                });
        },
    },
};
